"use strict";

var ButtonPrimary = React.createClass({
  getInitialState: function(){
    var state = {
      id: this.props.id || "btnAdicionarEmpresa",
      text: this.props.text || "Adicionar empresa",
      title: this.props.title || null,
      href: this.props.href || "/sistema/empresas/inserir.php",
      classes: "btnAdicionar "
    };
    if (this.props.classes) {
      state.classes += this.props.classes;
    }
    if (!state.title) {
      state.title = state.text;
    }
    return state;
  },
  render: function(){
    return (
      <div className={this.state.classes}>
        <a href={this.state.href} id={this.state.id} className="btn btn-primary" title={this.state.title}>
          {this.state.text}
        </a>
      </div>
    );
  }
});

module.exports = ButtonPrimary;



// WEBPACK FOOTER //
// ./app/shared/components/Button/button-primary.jsx